import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { ReceiveSquare, Edit2, Trash } from 'iconsax-react';
import ButtonWrapper from 'components/table/ActionButton/ButtonItem/ButtonWrapper';
import { IStaticImage } from 'utils/types/storyTypes';

interface IProps {
  handleClickDownload: (record: any) => void;
  setVisible: React.Dispatch<
    React.SetStateAction<{
      register: boolean;
      update: boolean;
      zip: boolean;
      delete: boolean;
    }>
  >;
  record: any;
  selectProject: any;
  setSelectedBackground: React.Dispatch<
    React.SetStateAction<IStaticImage | undefined>
  >;
  selectedBackground: any;
  visible: {
    register: boolean;
    update: boolean;
    zip: boolean;
    delete: boolean;
  };
}

const ActionBtn: React.FC<IProps> = ({
  handleClickDownload,
  setVisible,
  visible,
  record,
  selectProject,
  setSelectedBackground,
  selectedBackground,
}) => {
  const items: any = [
    {
      key: 1,
      item: (
        <ReceiveSquare size='24' onClick={() => handleClickDownload(record)} />
      ),
      hoverColor: theme.colors.green_500,
      color: theme.colors.dark_200,
    },
    {
      key: 2,
      item: (
        <Edit2
          size='24'
          onClick={() => {
            setSelectedBackground(record);
            setVisible({ ...visible, update: true });
          }}
        />
      ),
      hoverColor: theme.colors.blue_500,
      color: theme.colors.dark_200,
    },
    {
      key: 3,
      item: (
        <Trash
          size='24'
          onClick={() => {
            setSelectedBackground(record);
            setVisible({ ...visible, delete: true });
          }}
        />
      ),
      hoverColor: theme.colors.red_500,
      color: theme.colors.dark_200,
    },
  ];

  return (
    <>
      <MenuWrapper>
        {items.map((e, i) => (
          <ButtonWrapper key={i} color={e.color} hoverColor={e.hoverColor}>
            {e.item}
          </ButtonWrapper>
        ))}
      </MenuWrapper>
    </>
  );
};

export default ActionBtn;

const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 16px;
  }
`;

const ItemWrapper = styled.div<{ hoverColor: string }>`
  cursor: pointer;
  color: ${theme.colors.dark_200};
  &:hover {
    color: ${(props) => props.hoverColor};
  }
`;
